module.exports = __webpack_public_path__ + "img/the sun evolution 3-01.05321ef0.png";